<template>
  <div class="index-con">
    <img-description :title="obj1.title" :url="obj1.url" :desc="obj1.desc"></img-description>
    <img-description :title="obj2.title" :url="obj2.url" :desc="obj2.desc"></img-description>
    <img-description :title="obj3.title" :url="obj3.url" :desc="obj3.desc"></img-description>
    <img-description :title="obj4.title" :url="obj4.url" :desc="obj4.desc"></img-description>
  </div>
</template>

<script>
import ImgDescription from '@/components/content/ImgDescription'
export default {
  name: 'bandStroy',
  components: {
    ImgDescription
  },
  props: {
    lang: {
      type: String,
      default: 'zh'
    }
  },
  computed: {
    obj1() {
      return {
        'url': require("@/assets/images/BrandPredecessor.png"),
        'title': this.lang === 'zh' ? '品牌的由来' : 'Origin of Brand',
        'desc': this.lang === 'zh'
        ? `泡面大叔品牌不遗余力<br/>
        向更多人介绍世界各国的泡面，<br/>
        宣传泡面的历史、故事、分享泡面的煮法<br/>
        和特色食用方法以及各种泡面相关周边产品，<br/>
        以泡面为主的特色饮食文化影响更多人的舌尖。`
        : `The brand of instant noodles has spared no effort to introduce <br/>
        instant noodles from all over the world to more people, <br/>
        publicize the history and stories of instant noodles, <br/>
        share the cooking methods and special eating methods of instant noodles, <br/>
        and all kinds of products related to instant noodles. <br/>
        The special diet culture, which focuses on instant noodles, <br/>
        has influenced more people.`
      }
    },
    obj2() {
      return {
        'url': require("@/assets/images/BrandPredecessor.png"),
        'title': this.lang === 'zh' ? '品牌前身' : 'Brand Predecessor',
        'desc': this.lang === 'zh'
        ? `2016年9月，厦门遭受14号台风“莫兰蒂”重创，<br/>
        基础民生设施受到严重影响，<br/>
        政府及全市居民都争相投入灾后重建中。<br/>
        便捷且优质的进口泡面需求暴增，供不应求。<br/>
        创始人带领全员加急配送，<br/>
        亲自开车奔波于厦门各处送货，<br/>
        并向受灾群众赠送了大量泡面应急。<br/>
        大家为了感谢创始人的倾力相助，<br/>
        “泡面大叔”的名号由此而来。`
        : `In September 2016, Xiamen was hit hard by the 14th typhoon "Meranti", <br/>
        which seriously affected the basic livelihood facilities. <br/>
        The government and residents of the whole city rushed to invest <br/>
        in the post-disaster reconstruction.<br/>
        At this time, the demand for convenient and high-quality imported <br/>
        instant noodles has soared, and the supply is in short supply.<br/>
        The founder led all the staff to expedite delivery, <br/>
        personally drove around Xiamen to deliver goods, <br/>
        and presented a large number of instant noodles <br/>
        to the affected people for emergency response. <br/>
        In order to thank the founder for his help, <br/>
        the name "Uncle Instant Noodles" came from this.`
      }
    },
    obj3() {
      return {
        'url': require("@/assets/images/BrandPredecessor.png"),
        'title': this.lang === 'zh' ? '品牌理念' : 'Instant noodles Introduction',
        'desc': this.lang === 'zh'
        ? `2012年泡面大叔成立了第一家公司，<br/>
        主营预包装食品进出口贸易业务，<br/>
        受到国内消费升级的影响，<br/>
        市场对高品质的进口泡面的需求日渐增加，<br/>
        公司长期合作的连锁便利店、<br/>
        大型商超对进口泡面的采购量直线上升，<br/>
        泡面进出口业务逐渐成为公司的重要业务版块，<br/>
        为后续品牌打下坚实基础。`
        : `Uncle Noodle founded the first company in 2012, <br/>
        Mainly engaged in the import and export trade in prepackaged foods. <br/>
        Influenced by the upgrading of domestic consumption, <br/>
        the market demand for high-quality imported instant noodles is increasing day by day. <br/>
        The purchase volume of imported instant noodles <br/>
        by chain convenience stores and large supermarkets that <br/>
        the company has cooperated with for a long time has soared, <br/>
        and the import and export business of instant noodles has gradually <br/>
        become an important business section of the company, <br/>
        laying a solid foundation for subsequent brands.`
      }
    },
    obj4() {
      return {
        'url': require("@/assets/images/BrandPredecessor.png"),
        'title': this.lang === 'zh' ? '自幼萌生的执念' : 'Obsession From Childhood',
        'desc': this.lang === 'zh'
        ? `品牌创始人自童年开始便对泡面情有独钟，<br/>
        沉醉于它的多样风味，<br/>
        更痴迷于泡面时充满喜悦的仪式感。<br/>
        他秉着吃货的献身精神，<br/>
        搜罗了全世界的泡面品牌，<br/>
        尝遍了推陈出新的口味，<br/>
        终于把自己吃成了泡面世界的行家，<br/>
        对每款泡面如数家珍，<br/>
        并收藏着许多品牌的限量版泡面。`
        : `Brand founder has a special liking for instant noodles since his childhood,<br/>
        indulging in its diverse flavors and obsessed with <br/>
        the joyful ritual feeling of instant noodles. <br/>
        With the dedication of a foodie, he searched instant noodle brands all over the world, <br/>
        tasted all the new tastes, and finally became an expert in the instant noodle world. <br/>
        He knew every instant noodle like a few treasures <br/>
        and collected limited edition instant noodles of many brands.`
      }
    }
  }
}
</script>

<style lang="less">
.index-con {
  background-color: #ebebeb;
}
</style>



// WEBPACK FOOTER //
// src/components/content/BandStory/index.vue